"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getRelativeLuminance = _interopRequireDefault(require("get-relative-luminance"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Calculate contrast ratio.
 *
 * Definition: https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 */
var getContrastRatio = function getContrastRatio(color1, color2) {
  var l1 = (0, _getRelativeLuminance["default"])(color1);
  var l2 = (0, _getRelativeLuminance["default"])(color2);
  var lightest = Math.max(l1, l2);
  var darkest = Math.min(l1, l2);
  var contrast = (lightest + 0.05) / (darkest + 0.05);
  return Math.floor(contrast * 100) / 100;
};

var _default = getContrastRatio;
exports["default"] = _default;